import { toLinear, toOpaqueHex } from "./tableColor.js";
//#region src/utils/contrastText.ts
var CONTRAST_BLACK = "#000000";
var CONTRAST_WHITE = "#ffffff";
function relativeLuminance(color) {
	const hex = toOpaqueHex(color);
	if (!hex) return null;
	const [r, g, b] = [
		1,
		3,
		5
	].map((offset) => toLinear(parseInt(hex.slice(offset, offset + 2), 16)));
	return .2126 * r + .7152 * g + .0722 * b;
}
function contrastRatio(a, b) {
	return (Math.max(a, b) + .05) / (Math.min(a, b) + .05);
}
var BLACK_MIN_LEAD = 4;
function contrastTextColor(background) {
	const luminance = relativeLuminance(background);
	if (luminance === null) return null;
	const white = contrastRatio(luminance, 1);
	return contrastRatio(luminance, 0) - white > BLACK_MIN_LEAD ? CONTRAST_BLACK : CONTRAST_WHITE;
}
//#endregion
export { CONTRAST_BLACK, CONTRAST_WHITE, contrastRatio, contrastTextColor, relativeLuminance };
